module.exports = __webpack_public_path__ + "media/images/common/detail_1-a4e263b12851f2fcd06cc0ef4398f61c.png";